/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import * as Yup from 'yup';

const headerCss = css`
  border-bottom: 1px solid #ededed;
  padding-bottom: 15px;
  h4 {
    margin: 0 0 5px 0;
  }
`;

const oneBtnCss = css`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
`;

const twoBtnCss = css`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`;

const validationSchema = Yup.object().shape({
  cobrandList: Yup.array().required('At least one cobrand, client, or tag must be selected'),
  resourceType: Yup.number().required('Resource type is required'),
  findResource: Yup.object({
    id: Yup.number().required(),
    name: Yup.string().required()
  }).required('Find resource is required').nullable(),
  replaceResource: Yup.object({
    id: Yup.number().required(),
    name: Yup.string().required()
  }).required('Replace resource is required').nullable(),
});

function mapInitialValues() {
  const values = {
    client: [],
    cobrandTag: [],
    cobrand: [],
    cobrandList: [],
    resourceType: 0,
    findResource: { id: undefined, name: '' },
    replaceResource: { id: undefined, name: '' }
  };
  return values;
}

const resourceTypes = [
  { id: 1, name: 'Course' },
  { id: 2, name: 'Tool' },
  { id: 3, name: 'Banner 1' },
  { id: 4, name: 'Banner 2' },
  { id: 5, name: 'Banner 3' },
  { id: 6, name: 'Video' },
  { id: 7, name: 'Search' },
  { id: 8, name: 'Series' },
  { id: 9, name: 'Tag' },
  { id: 10, name: 'Banner 1 International' },
  { id: 11, name: 'Video International' },
  { id: 12, name: 'Mindfulness' },
  { id: 13, name: 'Series Intl' }
];

const endpointMap = (resourceType, cobrandIdParams) => {
  switch (resourceType) {
    case 1:
      return `internal/cobrands/crsids?${cobrandIdParams}`;
    case 2:
      return `internal/cobrands/tools?${cobrandIdParams}`;
    case 3:
    case 4:
    case 5:
      return `internal/cobrands/conids/false?${cobrandIdParams}`;
    case 6:
      return `internal/cobrands/videos/false?${cobrandIdParams}`;
    case 7:
      return `internal/cobrands/search?${cobrandIdParams}`;
    case 8:
    case 13:
      return `internal/cobrand/series`;
    case 9:
      return `internal/cobrands/tags?${cobrandIdParams}`;
    case 10:
      return `internal/cobrands/conids/true?${cobrandIdParams}`;
    case 11:
      return `internal/cobrands/videos/true?${cobrandIdParams}`;
    case 12:
      return `internal/cobrands/audios?${cobrandIdParams}`;
    default:
      return '';
  }
};

const successMsg = 'Featured Resources Updated.';

const setErrorMsg = (show, errors) => (
    show && Object.keys(errors).length > 0
        ? `Errors in: ${Object.keys(errors).join(', ')}. Check all required fields.`
        : 'Errors in form, check all required fields and try again.'
);

const replaceModalExplain = (resourceTypeName) => {
    return `Note: If the resource is not featured for a cobrand, the ${resourceTypeName} for that cobrand will be unchanged. Only the cobrands listed above will be affected.`;
}

export {
    headerCss,
    oneBtnCss,
    twoBtnCss,
    validationSchema,
    mapInitialValues,
    resourceTypes,
    endpointMap,
    successMsg,
    setErrorMsg,
    replaceModalExplain
};